import * as React from 'react';

// tslint:disable:max-line-length
export const PortalCheckoutTermsPBI: React.StatelessComponent = (props) => {
    return (
        <div>
            <h2>Terms and Conditions</h2>

            <ol>
                <li>
                    Payment terms are Net 10th or Net 30 upon credit application approval. Otherwise, prepayment must be arranged prior to shipping and/or shipments will deliver COD.
                </li>
                <li>
                    <span>Our cooling products are available for parcel shipping through UPS or FedEx on freight collect basis by confirmed written PO's only. All single piece orders must be placed by our cut-off times:</span>

                    <br />

                    <ul>
                        <li>3:00 PM PST  UPS (orders shipping from California)</li>
                        <li>3:00 PM PST  FedEx (orders shipping from California)</li>
                        <li>12:30 PM PST  UPS (orders shipping from Virginia)</li>
                        <li>12:30 AM PST  FedEx (orders shipping from Virginia)</li>
                        <li>1:00 PM PST  UPS (orders shipping from Texas)</li>
                        <li>1:00 PM PST  FedEx (orders shipping from Texas)</li>
                    </ul>

                    <br />

                    <em>Cut-off times may change and are not guaranteed. Our customer service team will notify you if any orders were unable to be shipped due to earlier pick-ups or shipping delays.</em>
                </li>
                <li>
                    If drop-shipping or using parcel delivery services, please provide shipping label for shipping accuracy and best rates. All appointments for pickup must be made by the customer.
                </li>
                <li>
                    A $9.00 non-refundable handling and packaging fee <em style={{ textDecoration: 'underline' }} >per piece</em> will be added to all single piece/parcel delivery shipments.
                </li>
                <li>
                    No cash refunds.
                </li>
                <li>
                    Any returns found not to be PBI product will be returned to the customer at the customer's expense. Non-PBI items will be scrapped if customer does not provide disposition advice within 7 days.
                </li>
                <li>
                    Wholesale pricing programs are for qualified warehouse distributors only, and are intended for stocking, rather than expediting. Thus, only defective items can be authorized for replacement or credit. Credit is issued only where the item in question is unavailable. Credit will not be given until testing and evaluation results are available. This process enables PBI to keep record of manufacturer defect and maintain. Any returns for lost sales or found not to be defective, will be subject to a 20% restocking fee. $10.00 re-boxing fee if required.
                </li>
                <li>
                    Special order items, special pricing items, and obsolete items (including discontinued items or to-be-discontinued items) are not returnable.
                </li>
                <li>
                    All the prices and terms are subject to change without prior notice and are not guaranteed against price decline.
                </li>
                <li>
                    Products priced with a warranty discount included are not eligible for any returns except for items made wrong and/or shipping errors.
                </li>
                <li>
                    Please email <a href="mailto:wholesale@pacificbestinc.com">wholesale@pacificbestinc.com</a> for any PO cancellations prior to shipping. Only written email cancellations will be accepted. Cancellations after shipping are not accommodated.
                </li>
                <li>
                    Customers must inspect received items promptly and report any issues within 48 hours. Claims for shipping-related issues will be addressed on a case-by-case basis. In the event of carrier damage, carrier delay, mislabeled parts (vendor or warehouse mislabeling issue), concealed damage, order processing errors, or warehouse shipping errors, PBI will process a replacement order using the original shipping method that was agreed upon. However, PBI will not process replacement orders via expedited services and is not responsible for any direct, indirect, incidental, consequential, punitive, or special loss or damage of any kind.
                </li>
                <li>
                    PBI’s customer service team opens at 8 AM PST in California. Please note that all will-call orders are processed during operation hours, and will-call orders placed prior to 8 AM PST will need to be picked up after 9 AM PST. Please allow up to 1 hour for will-call orders to be processed and prepared for pickup. This applies to email, online, and phone orders.
                </li>
                <li>
                    Our warehouse requires a minimum 1-hour lead time for will-call order processing, which means that most will-call orders should be submitted at least 1 hour in advance of pickup.
                </li>
                <li>
                    Drivers must be able to provide customer service and warehouse personnel with a valid Purchase Order number or reference number at the time of pickup.
                </li>
                <li>
                    Should you experience longer than normal hold times on the phone, we encourage you to email our team at <a href="mailto:wholesale@pacificbestinc.com">wholesale@pacificbestinc.com</a> for your inquiries and/or for order-related questions and concerns.
                </li>
                <li>
                    All will-call orders must be picked up within 48 hours. Orders not picked up within the 48-hour window will be canceled and returned to stock. If canceled orders are still needed, we will require that they are re-ordered with a new purchase order number assigned.
                </li>
                <li>
                    For all returns, please ensure an RMA # is assigned by emailing our wholesale department at <a href="mailto:wholesale@pacificbestinc.com">wholesale@pacificbestinc.com</a> prior to dropping off the item at one of our locations. All returns must be returned within 15 days of purchase and subject to 20% restocking charge.
                </li>
                <li>
                    Stock orders ship within 48 hours from the time of order, but may experience delays to accommodate freight carrier schedules and intracompany inventory transfers. Please contact customer service team for any questions regarding shipping status.
                </li>
                <li>
                    When calling for a price quote, please have the part #, DPI, OEM #, or Partslink information available. If you need to request a return, please ensure you have the invoice and part # on hand to provide our team members.
                </li>
                <li>
                    Order processing cut-off time is 5 PM PST. Orders must be submitted before 5 PM to be processed same day. If order is received after 5 PM PST, it will be processed and/or responded to the next day.
                </li>
            </ol>
        </div>
    );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutTermsPBI.tsx